module.exports = __webpack_public_path__ + "img/cp-event-habitat.d7d888fe.svg";